<template>
  <div>
    <AsyncModal
      :fetch="fetchFrequentlyAskedQuestions"
      :name="MODAL_NAMES.FAQ"
      :title="i18n(translations.title)"
    >
      <template #content>
        <div class="-mt-24 overflow-x-hidden">
          <RevAccordionList :has-external-borders="false">
            <RevAccordionItem
              v-for="question in questions"
              :key="question.title"
            >
              <template #title>
                <span class="body-1">
                  {{ question.title }}
                </span>
              </template>
              <template #body>
                <span class="body-2">
                  {{ question.text }}
                </span>
              </template>
            </RevAccordionItem>
          </RevAccordionList>
        </div>
        <WarrantyExclusion />
      </template>
    </AsyncModal>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import AsyncModal from '@backmarket/nuxt-layer-product-modals/AsyncModal.vue'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevAccordionList } from '@ds/components/AccordionList'

import { useUrlParams } from '~/scopes/product/composables/useUrlParams'
import { MODAL_NAMES } from '~/scopes/product/constants'

import WarrantyExclusion from '../../../WarrantyExclusion/WarrantyExclusion.vue'

import translations from './FaqModal.translations'

const props = defineProps<{
  listingId: number
}>()

const questions = ref()
const i18n = useI18n()
const $httpFetch = useHttpFetch()
const { productId } = useUrlParams()

async function fetchFrequentlyAskedQuestions() {
  try {
    const data = await $httpFetch(
      '/bm/product/:productId/listing/:listingId/faq',
      {
        pathParams: {
          productId,
          listingId: props.listingId,
        },
      },
    )

    questions.value = data.questions ?? []
  } catch {
    // Do nothing
  }
}
</script>
